import Swal from 'sweetalert2';

export function creditInvoiceBlockMessage(client) {
  if (!client || client.allow_credit !== false) return '';
  const name = client.client_name || 'este cliente';
  return `No se puede facturar a crédito a ${name} porque no tiene permitido el crédito.`;
}

export async function blockCreditInvoice(client, paymentType) {
  if (String(paymentType ?? '') !== '4') return false;
  const message = creditInvoiceBlockMessage(client);
  if (!message) return false;
  await Swal.fire({
    icon: 'warning',
    title: 'Crédito no permitido',
    text: message,
  });
  return true;
}
